import React from 'react';

function Divider() {
    return (
        <div className="divider"/>
    );
}

export default Divider;
